import { render, staticRenderFns } from "./WeekCalendarScheduleItem.vue?vue&type=template&id=5d6a87d2"
import script from "./WeekCalendarScheduleItem.vue?vue&type=script&lang=js"
export * from "./WeekCalendarScheduleItem.vue?vue&type=script&lang=js"
import style0 from "./WeekCalendarScheduleItem.vue?vue&type=style&index=0&id=5d6a87d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports